import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AxisSpinner from "../components/AxisSpinner";
import ShiftShiftStatusElement from "../components/ShiftShiftStatusElement";
import ShiftShiftDetailsElement from "../components/ShiftShiftDetailsElement";
import ShiftAssociatedBookingElement from "../components/ShiftAssociatedBookingElement";
import ShiftAuditTrailElement from "../components/ShiftAuditTrailElement";
import ShiftTimesheetElement from "../components/ShiftTimesheetElement";
import ShiftTimesheetHistoryElement from "../components/ShiftTimesheetHistoryElement";
import ShiftCancellationsElement from "../components/ShiftCancellationsElement";
import { Col, Container, Row } from "react-bootstrap";
import { AxisLineSeparator } from "../components/AxisLineSeparator";
import { BsCalendarWeekFill } from "react-icons/bs";
import {
  ButtonAssignShift,
  ButtonCancelShift,
  ButtonEditShift,
  ButtonSendTimesheetReminder,
} from "../components/ShiftShiftButtonActionsElements";
import AssignShiftModal from "../modals/AssignShiftModal";
import ShiftCreateUpdateModal from "../modals/ShiftCreateUpdateModal";
import CancelShiftModal from "../modals/CancelShiftModal";
import TimesheetReminderModal from "../modals/TimesheetReminderModal";

const ArchiveShift = () => {
  const { authAxios } = useAuth();
  const { shiftId } = useParams();
  const [loading, setLoading] = useState(true);
  const [shift, setShift] = useState(null);
  const [showShiftCreate, setShowShiftCreate] = useState(false);
  const [showAssignShift, setShowAssignShift] = useState(false);
  const [showCancelShift, setShowCancelShift] = useState(false);
  const [showTimesheetReminder, setShowTimesheetReminder] = useState(false);

  useEffect(() => {
    document.title = "Archive Shift";
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);

      var params = {
        shift_id: shiftId,
      };

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().get(
        "/api/backoffice/shifts/archive",
        config,
      );
      setLoading(false);

      setShift(response.data);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);

      // alert doesnt work
      // Alert.alert("Server Down", "Please try again later");
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;

    return (
      <Container fluid>
        <Row>
          <Col>
            <div>
              <ShiftShiftStatusElement shift={shift} />
            </div>
            <AxisLineSeparator />
            <div>
              <ShiftShiftDetailsElement shift={shift} />
            </div>
            <AxisLineSeparator />
            <div>
              <ShiftAuditTrailElement shift={shift} />
            </div>
          </Col>
          <Col>
            <div>
              <ShiftAssociatedBookingElement shift={shift} />
            </div>
            {shift?.digitalTimesheet === true && shift?.user?.id !== null ? (
              <AxisLineSeparator />
            ) : null}
            <div>
              <ShiftTimesheetElement
                shift={shift}
                updateShift={setShift}
                showActionButtons={true}
              />
            </div>
            {shift?.timesheet !== null && shift?.timesheet !== undefined ? (
              <AxisLineSeparator />
            ) : null}
            <div>
              <ShiftTimesheetHistoryElement shift={shift} />
            </div>
            <div>
              <ShiftCancellationsElement shift={shift} />
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  return (
    <Fragment>
      <Row className={"icon-text-wrapper"}>
        <Col>
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsCalendarWeekFill /> View Shift: {shift?.notificationId}
          </h1>
        </Col>
        <Col>
          <div className={"shift-button-container"}>
            <Container>
              <Row
                xs={"auto"}
                className={"justify-content-lg-end shift-button"}
              >
                <ButtonSendTimesheetReminder
                  shift={shift}
                  action={() => setShowTimesheetReminder(true)}
                />
                <ButtonCancelShift
                  shift={shift}
                  action={() => setShowCancelShift(true)}
                />
                <ButtonAssignShift
                  shift={shift}
                  action={() => setShowAssignShift(true)}
                />
                <ButtonEditShift
                  shift={shift}
                  action={() => setShowShiftCreate(true)}
                />
              </Row>
            </Container>
          </div>
        </Col>
      </Row>

      <AxisLineSeparator />

      {SpinnerOrData(loading)}

      <ShiftCreateUpdateModal
        visible={showShiftCreate}
        close={() => setShowShiftCreate(false)}
        shift={shift}
        updateShift={setShift}
      />
      <AssignShiftModal
        visible={showAssignShift}
        close={() => setShowAssignShift(false)}
        shift={shift}
        updateShift={setShift}
        pending={false}
      />
      <CancelShiftModal
        visible={showCancelShift}
        close={() => setShowCancelShift(false)}
        shift={shift}
        updateShift={setShift}
      />
      <TimesheetReminderModal
        visible={showTimesheetReminder}
        close={() => setShowTimesheetReminder(false)}
        shift={shift}
        updateShift={setShift}
      />
    </Fragment>
  );
};

export default ArchiveShift;
